import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {CategoryChangeItem} from './dashboardTableTypes'
import {
  renderDashboardDateTwoLine,
  renderDashboardSku,
} from './dashboardFormatters'

const columns: DashboardColumn<CategoryChangeItem>[] = [
  {header: 'SKU', sortKey: 'sku', render: (item) => renderDashboardSku(item.sku)},
  {header: 'Channel', sortKey: 'channel', render: (item) => item.channel ?? '-'},
  {header: 'Type', sortKey: 'type', render: (item) => item.type ?? '-'},
  {header: 'Old Value', sortKey: 'old_value', render: (item) => item.old_value ?? '-'},
  {header: 'New Value', sortKey: 'new_value', render: (item) => item.new_value ?? '-'},
  {header: 'Changed At', sortKey: 'changed_at', width: 160, render: (item) => renderDashboardDateTwoLine(item.changed_at)},
]

function CategoryChangesShow() {
  return (
    <DashboardApiTableShow<CategoryChangeItem>
      endpoint='CategoryChanges'
      title='Category Changes'
      columns={columns}
    />
  )
}

export default CategoryChangesShow
